<template>
  <div>
    <vxe-toolbar perfect>
      <template #buttons>
        <BOMItemAddAlternatePartForm
          ref="bomItemAddAltPartForm"
          :base-part="currentPart"
          :alternate-part="alternatePart"
          :readonly="readonly">
        </BOMItemAddAlternatePartForm>&nbsp;
        <Button type="text" @click="handleShowSimilarPartsClick">{{ $t('bom_tool.show_similar_parts') }}</Button>
      </template>
    </vxe-toolbar>
    <vxe-table
      size="mini"
      :data="alternatesData"
      :cell-class-name="alternativesTableCellClassName"
      :edit-config="{ trigger: 'click', mode: 'cell' }">
      <vxe-table-column type="seq" width="40" align="center"></vxe-table-column>
      <vxe-table-column v-if="!readonly"
                        field="preferred_status"
                        :title="$t('bom_tool.preferred_status')"
                        width="120"
                        align="center"
                        :edit-render="{}">
        <template #default="{ row }">{{ $t(`bom_tool.${row.preferred_status}`) }}</template>
        <template #edit="{ row }">
          <vxe-select v-model="row.preferred_status" transfer @change="handlePreferredStatusChange(row)">
            <vxe-option value="preferred" :label="$t('bom_tool.preferred')"></vxe-option>
            <vxe-option value="alternate" :label="$t('bom_tool.alternate')"></vxe-option>
          </vxe-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-else field="preferred_status" :title="$t('bom_tool.preferred_status')" width="120" align="center"></vxe-table-column>
      <vxe-table-column field="manufacturer_part.part_identity.part_number" :title="$t('bom_tool.part_number')" width="130"></vxe-table-column>
      <vxe-table-column field="manufacturer_part.mpn" :title="$t('bom_tool.manufacturer_part_number')" width="220"></vxe-table-column>
      <vxe-table-column field="manufacturer_part.brand" :title="$t('bom_tool.manufacturer_name')" width="200"></vxe-table-column>
      <vxe-table-column field="manufacturer_part.specification" :title="$t('bom_tool.specification')"></vxe-table-column>
      <vxe-table-column field="created_at" :title="$t('date')" width="160"></vxe-table-column>
      <vxe-table-column field="manufacturer_part.moderation_state" :title="$t('bom_tool.moderation_state')" align="center" width="130">
        <template #default="{ row }">{{ row.manufacturer_part.moderation_state ? row.manufacturer_part.moderation_state.toUpperCase() : '' }}</template>
      </vxe-table-column>
      <vxe-table-column field="manufacturer_part.lifecycle_status" :title="$t('bom_tool.lifecycle_status')" align="center" width="120">
        <template #default="{ row }">{{ row.manufacturer_part.lifecycle_status ? row.manufacturer_part.lifecycle_status.toUpperCase() : '' }}</template>
      </vxe-table-column>
      <vxe-table-column :title="$t('actions')" align="center" width="60">
        <template #default="{ row }">
          <Button type="text" icon="md-close" @click="handleItemRemoval(row)"></Button>
        </template>
      </vxe-table-column>
    </vxe-table>

    <div v-if="showSimilarPartsTable">
      <Divider>{{ $t('bom_tool.similar_parts_by_octopart') }}</Divider>

      <vxe-table :data="similarParts" size="mini" :loading="loadingSimilarParts">
        <vxe-table-column type="seq" width="40" align="center"></vxe-table-column>
        <vxe-table-column field="image_url" :title="$t('thumb')" width="82">
          <template #default="{ row }">
            <img v-if="row.image_url" :src="row.image_url" width="42"></img>
          </template>
        </vxe-table-column>
        <vxe-table-column field="mpn" :title="$t('bom_tool.manufacturer_part_number')" width="240">
          <template #default="{ row }"><span v-if="row.manufacturer_part_id"><Badge text="P" class="similar-parts--mapped-pangu" title="Found in Pangu">{{ row.mpn }}</Badge></span><span v-else>{{ row.mpn }}</span></template>
        </vxe-table-column>
        <vxe-table-column field="brand" :title="$t('bom_tool.manufacturer_name')" width="200"></vxe-table-column>
        <vxe-table-column field="specification" :title="$t('bom_tool.specification')"></vxe-table-column>
        <vxe-table-column field="description" :title="$t('bom_tool.description')"></vxe-table-column>
        <vxe-table-column :title="$t('links')" width="180">
          <template #default="{ row }">
            <ul style="list-style: none;">
              <li><a :href="row.datasheet_link" target="_blank">datasheet</a></li>
              <li v-if="row.manufacturer_url"><a :href="row.manufacturer_url" target="_blank">manufacturer</a></li>
              <li v-if="row.octopart_url"><a :href="row.octopart_url" target="_blank">octopart</a></li>
            </ul>
          </template>
        </vxe-table-column>
        <vxe-table-column :title="$t('actions')" width="120">
          <template #default="{ row }">
            <a @click="handleAddToBomClick(row)">Add as alternate</a>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>

<script>
import BOMItemAddAlternatePartForm from '@/view/bom/components/forms/bom-item-add-alternate-part-form'
import { getSimilarParts } from '@/api/part'
import { mapActions } from 'vuex'
export default {
  name: 'BOMItemPluginAlternates',
  components: {
    BOMItemAddAlternatePartForm
  },
  props: {
    alternates: Array,
    currentPart: Object,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      altPreferredStatusSelectOptions: [
        { label: 'Preferred', value: 'preferred' },
        { label: 'Alternate', value: 'alternate' }
      ],
      showSimilarPartsTable: false,
      loadingSimilarParts: false,
      similarParts: [],
      alternatePart: null
    }
  },
  computed: {
    alternatesData () {
      // Remove current part from alternates collection
      return _.filter(this.alternates, (it) => { return it.manufacturer_part_id !== this.currentPart.manufacturer_part_id })
    }
  },
  methods: {
    getSimilarParts,
    ...mapActions(['deleteBomItemPluginData', 'saveBomItemPluginData']),
    alternativesTableCellClassName ({ row, column }) {
      let classes = { invalid: 'error', draft: 'warning', reviewed: 'normal' }
      if (column.property === 'manufacturer_part.moderation_state') {
        return classes[row.manufacturer_part.moderation_state]
      }
    },
    handleShowSimilarPartsClick () {
      this.showSimilarPartsTable = true
      this.loadingSimilarParts = true
      this.getSimilarParts(this.currentPart.primary_manufacturer_part.component_type, this.currentPart.manufacturer_part_id).then(resp => {
        this.similarParts = resp.data
      }).finally(() => {
        this.loadingSimilarParts = false
      })
    },
    handleAddToBomClick (row) {
      this.alternatePart = row
      this.$refs['bomItemAddAltPartForm'].refresh({ base: this.currentPart, alternate: this.alternatePart }, true)
      this.$refs['bomItemAddAltPartForm'].showForm = true
    },
    handleItemRemoval (row) {
      this.deleteBomItemPluginData({ plugin: 'alternates', itemId: row.bom_item_id, key: row.id })
    },
    handlePreferredStatusChange (row) {
      this.saveBomItemPluginData({ plugin: 'alternates', itemId: row.bom_item_id, data: row })
    }
  }
}
</script>
<style lang="less">
.similar-parts--mapped-pangu.ivu-badge {
  sup.ivu-badge-count { right: -10px; background: #2db7f5; color: #ffffff; }
}
</style>
